module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_6000.75e29079.png";